class ProductGallery extends HTMLElement { // eslint-disable-line
  constructor() {
    super()
    this.swipers = this.querySelectorAll('.swiper')
    this.colorKey = `option${this.dataset.colorIndex}`
  }

  buildSwiperOptions(swiperEl) {
    return {
      slidesPerView: 1,
      threshold: 10,
      draggable: true,
      slidesPerGroup: 1,
      loop: true,
      mousewheel: {
        forceToAxis: true
      },
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: swiperEl.querySelector('.swiper-button-next'),
        prevEl: swiperEl.querySelector('.swiper-button-prev')
      }
    }
  }

  initSwiper(swiperEl, { resetOnUpdate = false } = {}) {
    const swiper = new Swiper(swiperEl, this.buildSwiperOptions(swiperEl))
    swiper.on('beforeSlideChangeStart', () => window.pauseAllMedia())
    if (resetOnUpdate) {
      document.addEventListener('updateProductGallery', () => swiper.slideTo(0, 0))
    }
    return swiper
  }

  connectedCallback() {
    if (!this.swipers.length) { return }
    const firstVisibleSwiperEl = [...this.swipers].find(el => !el.classList.contains('hidden'))
    this.initSwiper(firstVisibleSwiperEl)
  }

  updateProductGallery(variant) {
    if (!this.swipers.length) { return }

    const variantColor = variant[this.colorKey]

    this.swipers.forEach(swiper => {
      swiper.classList.toggle('hidden', variantColor !== swiper.dataset.color)
    })

    const activeSwiper = [...this.swipers].find(swiper => !swiper.classList.contains('hidden'))

    if (!activeSwiper.classList.contains('swiper-initialized')) {
      this.initSwiper(activeSwiper, { resetOnUpdate: true })
    }
  }
}

customElements.define('product-gallery', ProductGallery);

